import { registerPlugin } from '@capacitor/core';

import type { AuraginPlugin } from './definitions';

const Auragin = registerPlugin<AuraginPlugin>('Auragin', {
  web: () => import('./web').then(m => new m.AuraginWeb()),
});

export * from './definitions';
export { Auragin };
